import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { api } from '../../../config';

interface CustomHttpClientInterface {
  baseUrl: string;
  scope?: string;
}

const CustomHttpClient = ({
  baseUrl,
  scope = 'Productores',
}: CustomHttpClientInterface) => {
  return {
    baseUrl,
    headers: { scope },

    configureHeaders<D = any>(
      config?: AxiosRequestConfig<D>
    ): AxiosRequestConfig<D> {
      return config
        ? { ...config, headers: { ...this.headers, ...config.headers } }
        : { headers: this.headers };
    },

    delete<T = any, R = AxiosResponse<T>, D = any>(
      url: string,
      config?: AxiosRequestConfig<D>
    ): Promise<R> {
      return api.delete<T>(
        `${baseUrl}/${url}`,
        this.configureHeaders(config)
      ) as Promise<R>;
    },

    get<T = any, R = AxiosResponse<T>, D = any>(
      url: string,
      config?: AxiosRequestConfig<D>
    ): Promise<R> {
      return api.get<T>(
        `${baseUrl}/${url}`,
        this.configureHeaders(config)
      ) as Promise<R>;
    },

    patch<T = any, R = AxiosResponse<T>, D = any>(
      url: string,
      body?: D,
      config?: AxiosRequestConfig<D>
    ): Promise<R> {
      return api.patch<T>(
        url,
        body,
        this.configureHeaders(config)
      ) as Promise<R>;
    },

    post<T = any, R = AxiosResponse<T>, D = any>(
      url: string,
      body?: D,
      config?: AxiosRequestConfig<D>
    ): Promise<R> {
      return api.post<T>(
        `${baseUrl}/${url}`,
        body,
        this.configureHeaders(config)
      ) as Promise<R>;
    },

    put<T = any, R = AxiosResponse<T>, D = any>(
      url: string,
      body?: D,
      config?: AxiosRequestConfig<D>
    ): Promise<R> {
      return api.put<T>(
        `${baseUrl}/${url}`,
        body,
        this.configureHeaders(config)
      ) as Promise<R>;
    },
  };
};

export default CustomHttpClient;
